const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M0%2010L18.5898%2034.83L21.2565%2019.7368L0%2010Z'%20fill='%23309A5F'/%3e%3cpath%20d='M40%2010.5994L0%2010L21.2565%2019.7368L40%2010.5994Z'%20fill='%2394FFD1'/%3e%3cpath%20d='M21.2565%2019.737L18.5898%2034.8302L40%2010.5996L21.2565%2019.737Z'%20fill='%2361EA83'/%3e%3c/svg%3e";
export {
  e as default
};
